import { render, staticRenderFns } from "./SelectOrderingServices.vue?vue&type=template&id=407edad6&"
import script from "./SelectOrderingServices.vue?vue&type=script&lang=js&"
export * from "./SelectOrderingServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports